<template>
  <div class="container">
    <div class="row mt-4">
      <div class="col-md-3 col-0 col-xl-4" />
      <div class="col-md-6 col-12 col-xl-4">
        <h6 v-if="errorMessage != ''" class="text-danger">
          {{ errorMessage }}
        </h6>
        <form @submit.prevent="resetPassword">
          <div class="form-group">
            <label for="email">Email address</label>
            <input
              type="email"
              class="form-control"
              id="email"
              aria-describedby="emailHelp"
              placeholder="Email"
              autocomplete="username"
              v-model="email"
              required
            />
          </div>
          <div class="form-group">
            <label for="code">Verification Code</label>
            <input
              class="form-control"
              id="code"
              aria-describedby="emailHelp"
              placeholder="Verification Code "
              v-model="code"
              required
            />
          </div>
          <div class="form-group">
            <label for="password">New Password</label>
            <input
              type="password"
              class="form-control"
              id="password"
              placeholder="Password"
              autocomplete="new-password"
              v-model="newPassword"
              required
            />
          </div>

          <div class="form-group">
            <label for="confrimPassword">Confirm New Password</label>
            <input
              type="password"
              class="form-control"
              id="confrimPassword"
              placeholder="Confirm Password"
              autocomplete="new-password"
              v-model="confirmNewPassword"
              required
            />
          </div>
          <div class="text-center">
            <button class="btn btn-primary">Update Password</button>
          </div>
        </form>
      </div>
      <div class="col-md-3 col-0 col-xl-4" />
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";

export default {
  name: "Template",
  data() {
    return {
      email: "",
      code: "",
      newPassword: "",
      confirmNewPassword: "",
      errorMessage: ""
    };
  },
  mounted() {
    if (this.$route.query.email) {
      this.$data.email = this.$route.query.email;
    }
    if (this.$route.query.code) {
      this.$data.code = this.$route.query.code;
    }
  },
  methods: {
    resetPassword() {
      this.$store.commit("updateLoading", true);
      this.errorMessage = "";
      if (this.newPassword != this.confirmNewPassword) {
        this.errorMessage =
          "The two passwords do not match. Please verify the passwords and try again.";
        this.$store.commit("updateLoading", false);
      }
      if (this.errorMessage === "") {
        Auth.forgotPasswordSubmit(this.email, this.code, this.newPassword)
          .then(data => {
            console.log(data);
            this.$router.push("signin?passwordchanged=true");
            this.$store.commit("updateLoading", false);
          })
          .catch(err => {
            if (err.code == "UserNotFoundException") {
              this.errorMessage =
                "The email address you entered does not exist. Please verify your email address and try again.";
            } else if (err.code == "ExpiredCodeException") {
              this.errorMessage =
                'The code you entered is incorrect or expired. Please verify your code and try again. If the problem persists, please click "Forgot My Password" on the sign in page to receive a new code.';
            } else if (err.code == "LimitExceededException") {
              this.errorMessage =
                "You have exceeded the attempt limit to change your password. Please wait at least 30 minutes before trying again.";
            }
            console.log(err.code);
            this.$store.commit("updateLoading", false);
          });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
